import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Login_User } from "../../api/userAuth";
import { useNotify } from "../../context/NotifyContext";
import AuthShell from "../../components/auth/AuthShell";
import { AuthField, AuthPasswordInput } from "../../components/auth/AuthField";

const SignupForm = () => {
  const { notify } = useNotify();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const { username, password } = form;
    if (!username.trim() || !password.trim()) {
      notify("Please fill all fields!", "error");
      return false;
    }
    const usernameRegex = /^[A-Z0-9]{3,20}$/;
    if (!usernameRegex.test(username.toUpperCase())) {
      notify(
        "Username must be 3-20 characters, only letters and numbers.",
        "warning"
      );
      return false;
    }
    if (!password) {
      notify("Password must be at least 6 characters", "warning");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setLoading(true);
      const payload = {
        userName: form.username.toUpperCase(),
        password: form.password,
      };
      const result = await Login_User(payload);

      if (result.success) {
        const response = result?.data?.user || {};
        if (response.isActive) {
          notify(result.message || "Account logged in successfully!", "success");
          setForm({ username: "", password: "" });
          navigate(`/verify/mpin/${response?.userName}`);
        } else {
          notify("Account not active. Contact Admin.", "error");
        }
      } else {
        notify(result?.message || "Login failed!", "error");
      }
    } catch {
      notify("Something went wrong. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Let's get you started"
      title="Sign in to your account"
      subtitle="Enter your merchant username and password to continue."
    >
      {/* <form onSubmit={handleSubmit} noValidate autoComplete="off" className="flex flex-col gap-3.5"> */}
      <form
  onSubmit={handleSubmit}
  noValidate
  autoComplete="on"
  className="flex flex-col gap-3.5"
>
        <AuthField label="Username" required>
          <input
            className="ds-input"
            placeholder="Enter Username"
            value={form.username}
            name="username"
            onChange={(e) =>
              setForm({ ...form, username: e.target.value.toUpperCase() })
            }
            style={{ textTransform: "uppercase" }}
            autoComplete="username"
          />
        </AuthField>

        <AuthField label="Password" required>
          <AuthPasswordInput
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            show={showPassword}
            onToggle={() => setShowPassword((v) => !v)}
          />
        </AuthField>

        <div className="ds-auth-row">
          <span />
          <button
            type="button"
            className="ds-auth-link"
            onClick={() => navigate("/reset-password?from=signup")}
          >
            Forgot Password?
          </button>
        </div>

        <button
          type="submit"
          className="ds-btn ds-btn-primary ds-btn-block"
          disabled={loading}
        >
          {loading ? "Please wait..." : "Get Started"}
        </button>
      </form>
    </AuthShell>
  );
};

export default SignupForm;
